<template>
  <div>
    <div style="height:calc(100vh - 120px)" ref="fxAlertGrid"></div>
  </div>
</template>
<script>
import $ from '../../helpers/jquery-bridge'
import {enableExportExcel} from '../../helpers/export-helper'
import {getDataItem} from '@/helpers/kendo-helpers'
import {jsonDropDownEditor, checkboxColumn} from '../../helpers/kendo-editors'
import security from '@/mixins/security'

export default {
  mixins: [security],
  mounted() {
    let vm = this
    let grid = $(vm.$refs.fxAlertGrid)
      .kendoGrid({
        dataSource: new kendo.data.DataSource({
          type: 'aspnetmvc-ajax',
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
          pageSize: 16,
          transport: {
            create: {
              type: 'POST',
              url: '/api/config/fxAlert',
              dataType: 'json',
            },
            read: {
              type: 'GET',
              url: '/api/config/fxAlert',
              dataType: 'json',
            },
            update: {
              type: 'PUT',
              url: '/api/config/fxAlert',
              dataType: 'json',
            },
            destroy: {
              type: 'DELETE',
              url: '/api/config/fxAlert',
              dataType: 'json',
            },
          },
          schema: {
            data: 'data',
            errors: 'errors',
            total: 'total',
            model: {
              id: 'fxAlertId',
              fields: {
                fxAlertId: {type: 'number', validation: {required: true}},
                stampCodeId: {type: 'number', validation: {required: true}},
                provider: {type: 'string', validation: {required: true}},
                dataInstrumentId: {type: 'number', validation: {required: true}},
                fxLabel: {type: 'string', validation: {required: true}},
                showScreen: {type: 'boolean', defaultValue: true, validation: {required: true}},
                canDelete: {type: 'boolean', defaultValue: true, validation: {required: true}},
              },
            },
          },
          error: function() {
            grid.one('dataBinding', e => {
              e.preventDefault()
            })
          },
        }),
        toolbar: !vm.isReadOnly ? ['create'] : [],
        editable: !vm.isReadOnly && 'inline',
        filterable: true,
        sortable: true,
        pageable: true,
        columns: [
          {
            command: [{name: 'edit'}],
            width: 64,
            attributes: {style: 'text-align: center;'},
            hidden: vm.isReadOnly,
          },
          {
            field: 'provider',
            title: 'Provider',
            template: '#=provider#',
            width: 132,
            editor: jsonDropDownEditor(
              'stampCodeId',
              'stampCode',
              '/api/config/fxAlert/getStampCode',
              {
                change: e => {
                  let rowItem = getDataItem(e.sender.element)
                  rowItem.set('provider', e.sender.text())
                },
                dataBound: function(e) {
                  let rowItem = getDataItem(e.sender.element)
                  if (rowItem.fxAlertId == 0) this.select(0)
                  this.trigger('change')
                },
              },
              false,
            ),
          },
          {
            field: 'fxLabel',
            title: 'FX Label',
            width: 132,
            editor: jsonDropDownEditor(
              'dataInstrumentId',
              'code',
              '/api/config/fxAlert/getDataInstruments',
              {
                filter: 'contains',
                change: e => {
                  let rowItem = getDataItem(e.sender.element)
                  rowItem.set('fxLabel', e.sender.text())
                },
                dataBound: function(e) {
                  let rowItem = getDataItem(e.sender.element)
                  if (rowItem.fxAlertId == 0) this.select(0)
                  this.trigger('change')
                },
              },
              false,
            ),
          },
          checkboxColumn(
            'showScreen',
            {
              title: 'Show Screen',
              width: 120,
            },
            this.editable,
          ),
          {
            command: [{name: 'destroy', visible: dataItem => dataItem.canDelete}],
            width: 64,
            attributes: {style: 'text-align: center;'},
            hidden: vm.isReadOnly,
          },
          {},
        ],
      })
      .getKendoGrid()

    enableExportExcel(grid, '/api/config/fxAlert/exportToExcel')
  },
}
</script>
